import { render } from "./SignUp.vue?vue&type=template&id=5e069dd2"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"
script.render = render

export default script